import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";
import { restaurant } from "../lib/data";

export const Visit = () => {
  return (
    <section
      id="visit"
      data-testid="visit-section"
      className="relative bg-[#2c3528] text-[#f9f6f0] py-24 md:py-32 lg:py-40 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-30 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-12 gap-14 lg:gap-20">
        <div className="lg:col-span-5 reveal">
          <p className="overline text-[#f1c98a]">Come and Sit With Us</p>
          <h2 className="font-serif-display mt-6 text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Find the <span className="italic text-[#d98a6c]">taverna</span>.
          </h2>
          <p className="mt-8 text-[#f9f6f0]/80 text-lg leading-relaxed max-w-md">
            We&rsquo;re tucked into the heart of Planos&nbsp;Tsilivi. Pop in,
            ring ahead, or send us a quick message — we&rsquo;ll keep a chair
            ready for you.
          </p>

          <div className="mt-12 space-y-7">
            <div className="flex items-start gap-4">
              <MapPin
                className="h-5 w-5 mt-1 text-[#d98a6c]"
                strokeWidth={1.6}
              />
              <div>
                <p className="overline text-[#f1c98a]">Address</p>
                <p className="mt-1 font-serif-display text-2xl leading-tight">
                  {restaurant.location}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Clock
                className="h-5 w-5 mt-1 text-[#d98a6c]"
                strokeWidth={1.6}
              />
              <div>
                <p className="overline text-[#f1c98a]">Hours</p>
                <p className="mt-1 font-serif-display text-2xl leading-tight">
                  Daily · 11:00 – 00:30
                </p>
                <p className="mt-1 text-sm text-[#f9f6f0]/65 italic">
                  Kitchen closes 30 minutes before close.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="grid sm:grid-cols-3 gap-4 md:gap-6">
            <a
              href={`tel:${restaurant.phoneRaw}`}
              data-testid="visit-call-cta"
              className="lift group bg-[#f9f6f0] text-[#2c3528] p-7 flex flex-col justify-between min-h-[220px] hover:bg-[#d98a6c] hover:text-[#f9f6f0]"
            >
              <Phone className="h-7 w-7" strokeWidth={1.4} />
              <div>
                <p className="overline text-[#5b7053] group-hover:text-[#f1c98a]">
                  Call
                </p>
                <p className="font-serif-display text-3xl mt-2 leading-tight">
                  697 683 5281
                </p>
              </div>
            </a>
            <a
              href={`https://wa.me/${restaurant.whatsappRaw}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="visit-whatsapp-cta"
              className="lift group bg-[#f9f6f0] text-[#2c3528] p-7 flex flex-col justify-between min-h-[220px] hover:bg-[#5b7053] hover:text-[#f9f6f0]"
            >
              <MessageCircle className="h-7 w-7" strokeWidth={1.4} />
              <div>
                <p className="overline text-[#5b7053] group-hover:text-[#f1c98a]">
                  WhatsApp
                </p>
                <p className="font-serif-display text-3xl mt-2 leading-tight">
                  Message Us
                </p>
              </div>
            </a>
            <a
              href={`mailto:${restaurant.email}`}
              data-testid="visit-email-cta"
              className="lift group bg-[#f9f6f0] text-[#2c3528] p-7 flex flex-col justify-between min-h-[220px] hover:bg-[#2c3528] hover:text-[#f9f6f0] hover:outline hover:outline-1 hover:outline-[#f9f6f0]/30"
            >
              <Mail className="h-7 w-7" strokeWidth={1.4} />
              <div>
                <p className="overline text-[#5b7053] group-hover:text-[#f1c98a]">
                  Email
                </p>
                <p className="font-serif-display text-xl mt-2 leading-tight break-words">
                  {restaurant.email}
                </p>
              </div>
            </a>
          </div>

          <div className="mt-6 md:mt-8 relative aspect-[16/10] w-full overflow-hidden border border-[#f9f6f0]/15">
            <iframe
              title="The Greek Yum Yum's location map"
              data-testid="visit-map"
              src="https://www.google.com/maps?q=Yum+Yum+Traditional+Greek+Restaurant+Tsilivi+Planos+Zakynthos&output=embed"
              className="absolute inset-0 h-full w-full grayscale-[15%]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
